import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import PersonIcon from "@mui/icons-material/Person";

const InspectionDialog = ({ 
  open, 
  targetEmail, 
  isSwitching, 
  isDarkMode, 
  onConfirm, 
  onCancel 
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="inspect-dialog-title"
      PaperProps={{
        sx: {
          backgroundColor: isDarkMode ? "#060C18" : "#fff",
          borderRadius: "12px",
          padding: "8px",
          minWidth: "400px",
        }
      }}
    >
      <DialogTitle sx={{ 
        color: isDarkMode ? "#e2e8f0" : "#1a202c",
        borderBottom: `1px solid ${isDarkMode ? "#2d2d3f" : "#e0e0e0"}`,
        pb: 2 
      }}>
        <Box display="flex" alignItems="center" gap={1}>
          <PersonIcon sx={{ color: "#219297" }} />
          <Typography variant="h6" component="span" fontWeight="600">
            Inspect User
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography sx={{ color: isDarkMode ? "#e2e8f0" : "#4a5568", mb: 1 }}>
          You are about to enter 
        </Typography>
        {/* <Box 
          sx={{ 
            p: 2, 
            backgroundColor: isDarkMode ? "#0a1020" : "#e0ffff", 
            borderRadius: "8px",
            border: `1px solid ${isDarkMode ? "#2d2d3f" : "#b2fff5"}`,
            mb: 3
          }}
        >
          <Typography fontWeight="600" sx={{ color: "#219297", fontSize: "16px" }}>
            {targetEmail}
          </Typography>
        </Box> */}
        
        {/* <Typography variant="body2" sx={{ color: isDarkMode ? "#a0aec0" : "#718096", mb: 1 }}>
          <strong>Inspection Mode allows you to:</strong>
        </Typography>
        <Box component="ul" sx={{ color: isDarkMode ? "#a0aec0" : "#718096", mb: 2, pl: 2 }}>
          <Typography component="li" variant="body2">View the dashboard as this user</Typography>
          <Typography component="li" variant="body2">See their settings and configurations</Typography>
          <Typography component="li" variant="body2">Debug issues from their perspective</Typography>
        </Box> */}
        
        <Typography variant="body2" sx={{ color: isDarkMode ? "#a0aec0" : "#718096", mb: 2 }}>
          This action will log you out of your current session and switch to this user's account. 
          Your super admin privileges will be preserved for returning to your account.
        </Typography>
      </DialogContent>
      <Box sx={{ p: 3, pt: 0, display: "flex", gap: 2, justifyContent: "flex-end" }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          disabled={isSwitching}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            color: isDarkMode ? "#e2e8f0" : "#4a5568",
            borderColor: isDarkMode ? "#4a5568" : "#cbd5e1",
            "&:hover": {
              borderColor: "#219297",
              backgroundColor: "transparent",
            }
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isSwitching}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            backgroundColor: "#219297",
            "&:hover": {
              backgroundColor: "#36acb3",
            },
            "&:disabled": {
              backgroundColor: isDarkMode ? "#2d2d3f" : "#cbd5e1",
            }
          }}
        >
          {isSwitching ? (
            <Box display="flex" alignItems="center" gap={1}>
              <CircularProgress size={16} sx={{ color: "white" }} />
              Switching...
            </Box>
          ) : (
            "Enter Inspection Mode"
          )}
        </Button>
      </Box>
    </Dialog>
  );
};

export default React.memo(InspectionDialog);